import IConfigState from "./models/IConfigState";
import ConfigActions from "./ConfigAction";
import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";

export default class ConfigReducer extends BaseReducer<IConfigState> {
    public readonly initialState: IConfigState = {
        isIE: false,
        isSafari: false,
        onSearchFocus: false,
        embeddedMode: false,
    };

    public [ConfigActions.CONFIG_SET_IS_IE](state: IConfigState, action: IAction<boolean>): IConfigState {
        return {
            ...state,
            isIE: action.payload!,
        };
    }

    public [ConfigActions.CONFIG_SET_IS_SAFARI](state: IConfigState, action: IAction<boolean>): IConfigState {
        return {
            ...state,
            isSafari: action.payload!,
        };
    }

    public [ConfigActions.CONFIG_SET_EMBEDDED_MODE](state: IConfigState, action: IAction<boolean>): IConfigState {
        return {
            ...state,
            embeddedMode: action.payload!,
        };
    }

    public [ConfigActions.REQUEST_SIMULAZIONE_SET_SEARCH_ON_FOCUS](
        state: IConfigState,
        action: IAction<boolean>
    ): IConfigState {
        return {
            ...state,
            onSearchFocus: action.payload!,
        };
    }
}
